<article class="blog-page">
    <header class="blog-page__hero">
        <div class="container">
            <nav aria-label="breadcrumb" class="blog-page__breadcrumbs">
                <ol class="breadcrumb mb-0">
                    <li class="breadcrumb-item" data-aos="fade-down">
                        <a routerLink="/">Главная</a>
                    </li>
                    <li class="breadcrumb-item active" aria-current="page" data-aos="fade-down" data-aos-delay="70">
                        Блог
                    </li>
                </ol>
            </nav>
            <div class="blog-page__hero-copy" data-aos="fade-up">
                <div class="blog-page__eyebrow">База знаний</div>
                <h1 data-aos="fade-right" data-aos-delay="70">Блог MotorDesk</h1>
                <p>Практические материалы про учёт расходов, обслуживание, пробег, заправки, план ТО и стоимость владения автомобилем.</p>
                <a class="blog-page__channel-link" [href]="env.CHANNEL_URL" target="_blank" rel="noopener">
                    Анонсы новых материалов в Telegram-канале {{ env.CHANNEL_NAME }}
                </a>
            </div>
        </div>
    </header>

    <section class="container blog-page__list">
        <ng-container *ngIf="isLoading">
            <article class="blog-card blog-card--skeleton" *ngFor="let item of skeletonCards; let cardIndex = index"
                     aria-hidden="true" data-aos="fade-up" [attr.data-aos-delay]="getAosDelay(cardIndex, 80, 240)">
                <div class="blog-card__image">
                    <span class="blog-skeleton blog-skeleton--image"></span>
                </div>
                <div class="blog-card__body">
                    <span class="blog-skeleton blog-skeleton--date"></span>
                    <span class="blog-skeleton blog-skeleton--title"></span>
                    <span class="blog-skeleton blog-skeleton--text"></span>
                    <span class="blog-skeleton blog-skeleton--text blog-skeleton--short"></span>
                    <span class="blog-skeleton blog-skeleton--link"></span>
                </div>
            </article>
        </ng-container>

        <article class="blog-card" *ngFor="let post of posts; let cardIndex = index"
                 data-aos="fade-up" [attr.data-aos-delay]="getAosDelay(cardIndex, 80, 240)">
            <a class="blog-card__image" [routerLink]="['/blog', post.slug]" *ngIf="post.hero_image">
                <img [src]="post.hero_image.thumb_url" [alt]="post.hero_image.alt" loading="lazy" decoding="async">
            </a>
            <div class="blog-card__body">
                <time *ngIf="post.published_at">{{ post.published_at | date:'dd.MM.yyyy' }}</time>
                <h2><a [routerLink]="['/blog', post.slug]">{{ post.h1 || post.title }}</a></h2>
                <p>{{ post.excerpt || post.description }}</p>
                <a class="blog-card__link" [routerLink]="['/blog', post.slug]">Читать материал</a>
            </div>
        </article>

        <div class="blog-page__empty" *ngIf="!isLoading && !hasLoadError && !posts.length" data-aos="fade-up">
            Пока нет опубликованных материалов. Черновики можно готовить в админке через тип страницы "Запись блога".
        </div>

        <div class="blog-page__empty" *ngIf="!isLoading && hasLoadError" data-aos="fade-up">
            Не удалось загрузить материалы блога. Попробуйте обновить страницу.
        </div>
    </section>
</article>
